module.exports = __webpack_public_path__ + "img/arrow-white.ba343347.svg";